import { FuseNavigationItem } from '@fuse/types';

const annoScaricoPrecompilataDefault = new Date().getFullYear() - 1;

export const navigation: FuseNavigationItem[] = [
    {
        id: 'applications',
        title: 'Applications',
        translate: 'Cosa vuoi fare oggi?',
        type: 'group',
        children: [
            {
                id: 'dashboard',
                title: 'Dashboard',
                type: 'item',
                icon: 'label',
                url: '/dashboard',
            },
            {
                id: 'scadenziario-fiscale',
                title: 'Scadenziario fiscale',
                type: 'item',
                icon: 'calendar_today',
                badge: { title: 'beta', bg: '#3949ab', fg: '#ffffff' },
                roles: ['Admin', 'StudioAdmin'],
                url: '/scadenziario-fiscale',
            },
            {
                id: 'forfettario',
                title: 'Forfettario',
                type: 'collapsable',
                icon: 'label',
                roles: ['Admin', 'StudioAdmin', 'StudioTicketUser'],
                children: [
                    {
                        id: 'forfettario-dati',
                        title: 'Dati',
                        type: 'item',
                        icon: 'label',
                        url: '/forfettario/dati',
                    },
                    {
                        id: 'contabilità',
                        title: 'Contabilità',
                        type: 'collapsable',
                        icon: 'label',
                        children: [
                            {
                                id: 'forfettario-fatture-attive',
                                title: 'Documenti attivi',
                                type: 'item',
                                icon: 'label',
                                url: '/forfettario/contabilita/fatture-attive',
                            },
                            {
                                id: 'forfettario-fatture-passive',
                                title: 'Documenti passivi',
                                type: 'item',
                                icon: 'label',
                                url: '/forfettario/contabilita/fatture-passive',
                            },
                            {
                                id: 'forfettario-fatture-importate',
                                title: 'Documenti importati',
                                type: 'item',
                                icon: 'label',
                                url: '/forfettario/contabilita/fatture-importate',
                            },
                            {
                                id: 'forfettario-corrispettivi',
                                title: 'Corrispettivi',
                                type: 'item',
                                icon: 'label',
                                url: '/forfettario/contabilita/corrispettivi',
                            },
                            {
                                id: 'incassi',
                                title: 'Incassi',
                                type: 'item',
                                icon: 'label',
                                url: '/forfettario/contabilita/pagamenti-incassi',
                            },
                            {
                                id: 'forfettario-stampe',
                                title: 'Stampa',
                                type: 'item',
                                icon: 'label',
                                url: '/forfettario/contabilita/stampe',
                            },
                        ],
                    },
                    {
                        id: 'crediti',
                        title: 'Crediti',
                        type: 'item',
                        icon: 'label',
                        url: '/forfettario/crediti',
                    },
                    {
                        id: 'agenzia-entrate-riscossione',
                        title: 'A.E. Riscossione',
                        type: 'item',
                        icon: 'label',
                        url: '/forfettario/agenzia-entrate-riscossione',
                    },
                    {
                        id: 'documenti-forfettari',
                        title: 'Documenti',
                        type: 'item',
                        icon: 'label',
                        url: '/forfettario/documenti',
                    },
                    {
                        id: 'cassettoFiscale',
                        title: 'Cassetto fiscale',
                        type: 'item',
                        icon: 'label',
                        url: '/cassetto-fiscale',
                    },

                    {
                        id: 'scadenze',
                        title: 'Scadenze',
                        type: 'item',
                        icon: 'label',
                        url: '/forfettario/scadenze',
                    },
                    // {
                    //     id: 'situazioni-da-controllare',
                    //     title: 'Situazioni da controllare',
                    //     type: 'item',
                    //     icon: 'label',
                    //     url: '/forfettario/situazioni-da-controllare',
                    //     hidden: true,
                    // },
                    {
                        id: 'dichiarazione',
                        title: 'Dichiarazione',
                        type: 'item',
                        icon: 'label',
                        url: '/forfettario/dichiarazione',
                    },
                    {
                        id: 'criticita-utente',
                        title: 'Criticità',
                        type: 'item',
                        icon: 'label',
                        url: '/forfettario/criticita',
                    },
                    {
                        id: 'inail',
                        title: 'Inail',
                        type: 'item',
                        icon: 'label',
                        url: '/forfettario/inail',
                    },
                ],
            },

            {
                id: 'forfettari-in-registrazione',
                title: 'Forfettari in registrazione',
                type: 'collapsable',
                icon: 'label',
                roles: ['Admin', 'StudioAdmin', 'StudioTicketUser'],
                children: [
                    {
                        id: 'registrazione-spid',
                        title: 'Registrazioni SPID',
                        type: 'item',
                        icon: 'label',
                        url: '/registrazioni/spid',
                    },
                    {
                        id: 'registrazioni-comletate',
                        title: 'Registrazioni Completate',
                        type: 'item',
                        icon: 'label',
                        url: '/registrazioni/completate',
                    },
                    {
                        id: 'aperture-partita-iva',
                        title: 'Aperture Partita IVA',
                        type: 'item',
                        icon: 'label',
                        url: '/registrazioni/apertura-partita-iva',
                    },
                ],
            },
            {
                id: 'criticita',
                title: 'Criticità',
                type: 'item',
                icon: 'label',
                url: '/criticita',
                roles: ['Admin', 'StudioAdmin'],
            },
            {
                id: 'importazioni-storico-enti',
                title: 'Importazioni storico da enti',
                type: 'item',
                icon: 'label',
                url: '/importazioni-storico-da-enti',
            },
            {
                id: 'concordato-preventivo',
                title: 'Concordato preventivo',
                type: 'item',
                icon: 'label',
                url: '/concordato-preventivo',
                roles: ['Admin', 'StudioAdmin'],
            },
            {
                id: 'gestione-inps',
                title: 'Gestione INPS art/com',
                type: 'collapsable',
                icon: 'label',
                roles: ['Admin', 'StudioAdmin'],
                children: [
                    {
                        id: 'gestione-inps-deleghe',
                        title: 'Controllo deleghe',
                        type: 'item',
                        icon: 'label',
                        url: '/gestione-inps/controllo-deleghe',
                    },
                    {
                        id: 'gestione-inps-aggiornamento',
                        title: 'Aggiornamento dati',
                        type: 'item',
                        icon: 'label',
                        url: '/gestione-inps/aggiornamento-dati',
                    },
                    {
                        id: 'gestione-inps-controllo-contribuzioni',
                        title: 'Controllo contribuzioni',
                        type: 'item',
                        icon: 'label',
                        url: '/gestione-inps/controllo-contribuzioni',
                    },
                ],
            },

            {
                id: 'dichiarazioni-dei-redditi',
                title: 'Dichiarazioni dei redditi',
                type: 'collapsable',
                icon: 'label',
                roles: ['Admin', 'StudioAdmin', 'StudioTicketUser'],
                children: [
                    {
                        id: 'scarico-precompilata',
                        title: 'Scarico Precompilata',
                        type: 'item',
                        icon: 'label',
                        url: `/emissioni/scarico-precompilata/${annoScaricoPrecompilataDefault}`,
                    },
                    {
                        id: 'emissione-nuova-2025',
                        title: 'Emissione RPF 2026',
                        type: 'item',
                        icon: 'label',
                        url: '/emissioni/dichiarazioni-nuova/2026',
                    },
                    {
                        id: 'emissione-nuova-2025',
                        title: 'Emissione RPF 2025',
                        type: 'item',
                        icon: 'label',
                        url: '/emissioni/dichiarazioni-nuova/2025',
                    },
                    {
                        id: 'emissione-nuova-2024',
                        title: 'Emissione RPF 2024',
                        type: 'item',
                        icon: 'label',
                        url: '/emissioni/dichiarazioni-nuova/2024',
                    },
                    {
                        id: 'emissione-nuova-2023',
                        title: 'Emissione RPF 2023',
                        type: 'item',
                        icon: 'label',
                        url: '/emissioni/dichiarazioni-nuova/2023',
                    },
                    {
                        id: 'emissione-nuova-2022',
                        title: 'Emissione RPF 2022',
                        type: 'item',
                        icon: 'label',
                        url: '/emissioni/dichiarazioni-nuova/2022',
                    },
                    {
                        id: 'emissione-nuova-2021',
                        title: 'Emissione RPF 2021',
                        type: 'item',
                        icon: 'label',
                        url: '/emissioni/dichiarazioni-nuova/2021',
                    },
                ],
            },
            {
                id: 'gestione-tabelle',
                title: 'Gestione Tabelle',
                type: 'collapsable',
                icon: 'label',
                roles: ['Admin', 'StudioAdmin'],
                children: [
                    {
                        id: 'tabella-contribuzioni',
                        title: 'Tabella contribuzioni',
                        type: 'item',
                        icon: 'label',
                        url: '/gestione-tabelle/tabella-contribuzioni',
                    },
                    {
                        id: 'irpef',
                        title: 'Irpef',
                        type: 'item',
                        icon: 'label',
                        url: '/gestione-tabelle/irpef',
                    },
                    {
                        id: 'ateco',
                        title: 'Ateco',
                        type: 'item',
                        icon: 'label',
                        url: '/gestione-tabelle/ateco',
                    },
                    {
                        id: 'intrastat',
                        title: 'Intrastat',
                        type: 'item',
                        icon: 'label',
                        url: '/gestione-tabelle/intrastat',
                    },
                    {
                        id: 'enasarco',
                        title: 'Enasarco',
                        type: 'collapsable',
                        icon: 'label',
                        children: [
                            {
                                id: 'agevolazioni-enasarco',
                                title: 'Agevolazioni',
                                type: 'item',
                                icon: 'label',
                                url: '/gestione-tabelle/enasarco/agevolazioni',
                            },
                            {
                                id: 'agevolazioni-enasarco',
                                title: 'Parametri',
                                type: 'item',
                                icon: 'label',
                                url: '/gestione-tabelle/enasarco/parametri',
                            },
                        ],
                    },
                    {
                        id: 'ccia',
                        title: 'Camera di commercio',
                        type: 'collapsable',
                        icon: 'label',
                        children: [
                            {
                                id: 'importi-diritto-camerale',
                                title: 'Importi diritto camerale',
                                type: 'item',
                                icon: 'label',
                                url: '/gestione-tabelle/camera-di-commercio/importi-diritto-camerale',
                            },
                        ],
                    },
                    {
                        id: 'tabella-classificazione-costi',
                        title: 'Classificazione costi',
                        type: 'item',
                        icon: 'label',
                        url: '/gestione-tabelle/classificazione-costi',
                    },
                    {
                        id: 'parametri',
                        title: 'Parametri',
                        type: 'collapsable',
                        icon: 'label',
                        children: [
                            {
                                id: 'parametri-inail',
                                title: 'Inail',
                                type: 'item',
                                icon: 'label',
                                url: '/gestione-tabelle/parametri/inail',
                            },
                            {
                                id: 'parametri-generali',
                                title: 'Generali',
                                type: 'item',
                                icon: 'label',
                                url: '/gestione-tabelle/parametri/generali',
                            },
                            {
                                id: 'parametri-rate',
                                title: 'Rate',
                                type: 'item',
                                icon: 'label',
                                url: '/gestione-tabelle/parametri/rate',
                            },
                        ],
                    },
                    {
                        id: 'enti-creditori',
                        title: 'Enti creditori',
                        type: 'item',
                        icon: 'label',
                        url: '/gestione-tabelle/enti-creditori',
                    },
                ],
            },
            {
                id: 'auto-liquidazione-inail',
                title: 'Autoliquidazione Inail',
                type: 'item',
                icon: 'label',
                url: '/auto-liquidazione-inail',
                roles: ['Admin', 'StudioAdmin'],
            },
            {
                id: 'gestione-scadenze',
                title: 'Gestione scadenze',
                type: 'item',
                icon: 'label',
                url: '/gestione-scadenze',
                roles: ['Admin', 'StudioAdmin'],
            },
            {
                id: 'gestione-affiliazioni',
                title: 'Gestione affiliazioni',
                type: 'item',
                icon: 'label',
                url: '/gestione-affiliazioni',
                roles: ['Admin', 'StudioAdmin'],
            },
            {
                id: 'gestione-ateco',
                title: 'Gestione Ateco',
                type: 'item',
                icon: 'label',
                url: '/gestione-ateco',
                roles: ['Admin', 'StudioAdmin'],
            },
            {
                id: 'gestione-invii-intrastat',
                title: 'Gestione invii Intrastat',
                type: 'item',
                icon: 'label',
                url: '/gestione-invii-intrastat',
                roles: ['Admin', 'StudioAdmin'],
            },
            {
                id: 'gestione-invii-f24',
                title: 'Gestione invii F24',
                type: 'item',
                icon: 'label',
                url: '/gestione-invii-f24',
                roles: ['Admin', 'StudioAdmin'],
            },
            {
                id: 'gestione-bolli',
                title: 'Gestione bolli',
                type: 'item',
                icon: 'label',
                url: '/gestione-bolli',
                roles: ['Admin', 'StudioAdmin'],
            },
            // {
            //     id: 'gestione-controlli-coerenza',
            //     title: 'Gestione controlli coerenza',
            //     type: 'item',
            //     icon: 'label',
            //     url: '/gestione-controlli-coerenza',
            //     roles: ['Admin', 'StudioAdmin'],
            // },
            {
                id: 'ruoli-operatori',
                title: 'Ruoli e operatori',
                type: 'item',
                icon: 'label',
                url: '/ruoli-operatori',
                roles: ['Admin', 'StudioAdmin'],
            },
            {
                id: 'fatturazione-elettronica',
                title: 'Fatturazione elettronica',
                type: 'collapsable',
                icon: 'label',
                roles: ['Admin', 'StudioAdmin'],
                children: [
                    {
                        id: 'invii-sdi-fnc',
                        title: 'Invii Fnc',
                        type: 'item',
                        icon: 'label',
                        url: '/fatturazione-elettronica/invii-sdi/provider-sdi/1',
                    },
                ],
            },
            {
                id: 'fnc',
                title: 'Fnc',
                type: 'collapsable',
                icon: 'label',
                roles: ['Admin', 'StudioAdmin'],
                children: [
                    {
                        id: 'documenti-attivi',
                        title: 'Documenti attivi',
                        type: 'item',
                        icon: 'label',
                        url: '/fnc/documenti-attivi',
                    },
                ],
            },
        ],
    },
];
